module.exports = __webpack_public_path__ + "static/media/right-menu-referral-icon.d564abe5.svg";